<template>
  <div class="result">
    <div class="success">
      <div class="success__image"/>
      <div class="success__data">
        <span class="success__data-title">Паспорт</span>
        <span class="success__data-text" v-for="(namePart, i) in name" :key="'p'+i">{{ namePart }}</span>
        <span class="success__data-date">{{ result.birthDate }}</span>
      </div>

      <div class="success__id">{{passport}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Result",
  props: ['result'],
  computed: {
    name() {
      return this.result?.fullName?.replaceAll('*', '•').split(' ') || []
    },
    passport() {
      return this.result?.passport?.replaceAll('*', '•') || '•••• ••••••'
    }
  }
}
</script>

<style lang="less" scoped>
.result {
  margin-top: 60px;
}

.success {
  width: 100%;
  background-color: white;
  border-radius: 3px 3px 14px 14px;
  position: relative;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.25);
  display: flex;
  padding: 15px 12px 30px;

  &__image {
    width: 55px;
    height: 75px;
    min-width: 55px;
    border-radius: 7px;
    background-color: #efefef;
    background-image: url("data:image/svg+xml,%3Csvg width='46' height='52' viewBox='0 0 46 52' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.6274 0.399571C18.1884 1.4855 15.8432 3.00339 13.2704 5.16127C12.2006 6.05852 12.1822 6.06818 10.8236 6.44373C7.92476 7.2451 5.25793 8.12051 3.19733 8.94701C1.58215 9.59496 1.31801 9.8653 1.31801 10.8709C1.31801 11.3852 1.37082 11.5358 1.67125 11.8777C2.15616 12.4297 2.45557 12.4066 4.41592 11.6655C6.53319 10.865 7.81995 10.4374 7.89267 10.5099C7.92464 10.542 7.89995 10.6335 7.83759 10.7132C7.77534 10.7929 7.31251 11.3786 6.80905 12.0148C3.54943 16.1344 2.08481 19.3432 0.987874 24.7676C-0.514761 32.1985 -0.326192 36.3427 1.71165 40.6704C4.11787 45.7803 9.91014 49.8945 17.085 51.5902C18.3495 51.8891 18.6132 51.9118 20.835 51.9139C23.5539 51.9164 24.2577 51.8091 26.525 51.0468C34.3566 48.4137 41.7206 41.0439 44.4645 33.0931C44.8824 31.8823 45.4012 29.8097 45.6032 28.5437C45.835 27.0913 45.8057 23.3106 45.552 21.9223C44.9637 18.7053 43.9859 16.2662 42.2634 13.7203C41.3384 12.3528 38.8276 9.84256 37.45 8.90766C36.5026 8.26473 36.2229 8.09265 35.2024 7.52455C34.5977 7.18778 32.6979 6.38311 31.9173 6.13312C30.2475 5.59823 28.9709 5.33005 26.4681 4.98862C25.3772 4.83974 20.5565 4.80198 19.3841 4.933C18.7662 5.00204 18.6274 4.9893 18.6747 4.86761C18.7523 4.66709 19.1646 4.42496 21.0543 3.47005C22.9204 2.52708 23.111 2.33157 23.111 1.36039C23.111 0.777964 23.0689 0.649899 22.7768 0.345206C22.321 -0.130316 21.7871 -0.116781 20.6274 0.399571ZM24.9887 7.84437C28.882 8.10811 31.9284 8.93701 34.5833 10.4551C40.3766 13.7677 43.6036 20.6352 42.6787 27.6832C42.0496 32.4769 39.7605 37.1763 36.133 41.121C33.1494 44.3653 29.2737 46.9997 25.6883 48.22C21.5787 49.6189 17.2574 49.1863 12.6171 46.9115C6.384 43.8559 2.91123 39.0241 2.91123 33.4072C2.91123 32.6016 2.95835 31.6 3.01593 31.1814C3.07351 30.7628 3.18049 29.9597 3.25378 29.3967C3.82426 25.0102 4.75846 21.5751 6.22286 18.4783C7.38784 16.0148 9.65989 12.9034 12.3399 10.1018L13.4881 8.90141L14.7148 8.66279C16.5815 8.29964 19.0705 7.97072 20.7781 7.86154C22.9724 7.72119 23.1582 7.7204 24.9887 7.84437ZM24.1045 18.3143C23.5522 18.5948 22.88 19.3152 22.6324 19.892C22.062 21.2206 22.3684 23.3618 23.2453 24.1739C24.2327 25.0886 25.7598 24.9853 26.6764 23.9421C27.0897 23.4717 27.14 23.3114 27.2141 22.2315C27.2442 21.7936 27.2971 21.0499 27.3318 20.5789C27.3928 19.75 27.3827 19.7045 27.0168 19.1651C26.3507 18.183 25.0886 17.8143 24.1045 18.3143ZM15.9571 20.0666C14.5901 20.5536 13.9264 22.3485 14.5262 23.9367C14.9025 24.9329 15.8472 25.8522 16.688 26.0403C18.6812 26.486 20.117 24.6286 19.3084 22.6506C19.1886 22.3575 19.0596 21.9399 19.0217 21.7225C18.9149 21.1107 18.4302 20.5099 17.7841 20.188C17.1403 19.8674 16.6141 19.8325 15.9571 20.0666ZM32.1856 29.718C31.8345 29.913 31.6476 30.2039 31.3248 31.0575C30.7717 32.521 30.0753 33.5636 28.8971 34.6923C27.7091 35.8305 26.5604 36.5331 25.0456 37.0478C23.6905 37.5083 23.1554 37.5812 21.1764 37.5746C19.574 37.5694 19.0756 37.5256 18.2744 37.3201C16.3136 36.8172 14.9464 36.0747 14.0623 35.033C12.9334 33.7028 12.8808 33.6617 12.3055 33.6617C10.8606 33.6617 10.2207 34.8648 11.0016 36.1132C12.6242 38.7072 16.1087 40.3971 20.3798 40.6613C25.5312 40.9798 30.0677 38.8471 32.7897 34.8269C33.663 33.5371 34.548 31.569 34.548 30.9169C34.548 30.5255 34.2223 29.9667 33.8743 29.7613C33.4884 29.5335 32.561 29.5098 32.1856 29.718Z' fill='%23e4e4e4'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-size: 60%;
    background-position: center;
  }

  &__data {
    margin: 0 18px;
    font-weight: bold;
    overflow: hidden;

    span {
      display: block;
      text-align: start;
    }

    &-title {
      color: #999;
      text-transform: uppercase;
      letter-spacing: .25em;
      font-size: 0.75rem;
      margin-bottom: 6px;
    }

    &-text, &-date {
      font-family: 'Source Code Pro', monospace;
      line-height: 1.6;
      letter-spacing: 0.3em;
    }

    &-date {
      letter-spacing: initial;
      margin-top: 5px;
    }
  }

  &__id {
    writing-mode: vertical-rl;
    text-orientation: mixed;
    margin-left: auto;
    font-family: 'Source Code Pro', monospace;
    font-weight: bold;
    color: #D07929;
    font-size: 1.2rem;
    margin-top: 5px;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    background: e('linear-gradient(to bottom, rgba(255, 255, 255, 0), white);');
    border-radius: 0 0 5px 5px;
    width: 100%;
    height: 40px;
    left: 0;
    top: -44px;
  }
}
</style>
